<<template>
  <v-app id="inspire">
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <v-content>
      <v-img style="position:fixed; width:100%; height:100%;" position="100% 100%" src="Attraction/body.jpg"
        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"></v-img>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm6 md4 lg4 xl4>
            <v-card class="elevation-12" color="rgb(255, 255, 255, 0.6">
              <v-form @submit.prevent="login">
                <v-card-text>
                  <v-layout align-center justify-center row mb-2>
                    <v-img width="100%" height="100%" src="Attraction/suburban.png">
                    </v-img>
                  </v-layout>
                  <v-text-field v-model="Username" color="primary" prepend-icon="person" name="login" label="Login"
                    type="text"></v-text-field>
                  <v-text-field prepend-icon="lock" label="Password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'"
                    v-model="Password" name="password" color="primary" id="password">
                  </v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" block type="submit">Login</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
  </template>

  <script>
    import JWT from "jsonwebtoken";
    import supervisorMW from "@/libs/middleware/supervisorMW";

    export default {
      data() {
        return {
          showPassword: false,
          Username: null,
          Password: null,
          userID: null,
        };
      },
      mounted() {
        localStorage.clear();
        let mw = new supervisorMW(self);

        mw.DeleteUserData()
        .then(r=> {
          // deleted successfully
        })
        .catch(e=> {
          // deleted FAILED
        })
      },
      methods: {
        login() {
          let self = this;

          self
            .get(
              `Authentication/User/Login?username=${self.Username}&password=${
            self.Password
          }`,
              null,
              false
            )
            .then(r => {
              console.log(r);
              self.checkRole(r.data.Role);
              self.$store.commit("setUserSessionData", r.data);
              sessionStorage.setItem("accessToken", r.data.AccessToken);
              sessionStorage.setItem("refreshToken", r.data.RefreshToken);

              localStorage.setItem('accessToken', r.data.AccessToken);
              localStorage.setItem('refreshToken', r.data.RefreshToken);

              let tokenDecoded = JWT.decode(localStorage.accessToken);
              self.userID = tokenDecoded.USER_ID;
              console.log("USER_ID", self.userID);
              localStorage.setItem('USER_ID', self.userID);
              //self.$refs.Loader.hide();
            })
            .catch(error => {
              //   self.$refs.Loader.hide();
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText(error.toString());
            });
        },
        StoreUserDataInIndexedDB(data) {
          let self = this;
          let mw = new supervisorMW(self);
          console.log(self.userID, data)
          self.$nextTick(() => {
            mw.PostUserData(self.userID, data).then(r => {
              self.$router.push("/Supervisor");
            })
          })
        },
        checkRole(role) {
          let self = this;

          switch (role.Name.toUpperCase()) {
            case "MASTER": {
              self.$router.push("/Main");
            }
            break;
          case "ADMIN": {
            self.$router.push("/Main");
          }
          break;
          case "REGIONAL MANAGER": {
            self.$router.push("/Main");
          }
          break;
          case "OPSMANAGER": {
            self.$router.push("/OpsManager");
          }
          break;
          case "SUPERVISOR": {
            self.$nextTick(() => {
              self.get(`Mobile/Supervisor?systemUserID=${self.userID}`).then(r => {
                console.log("[USERS DATA]", r.data)
                if (r.data != null) {
                  self.StoreUserDataInIndexedDB(r.data); // store user data in indexed db
                } else {
                  self.$refs.ErrorModal.setText("Cannot fetch this user's data");
                  self.$refs.ErrorModal.show();
                }
              })
            })
          }
          break;
          }
        }
      }
    };
  </script>

  <style>
  </style>